import "./WizardStepComponent.scss";
import {WizardComponentController} from "../WizardComponent";
import {IFormController, IOnInit, IRootElementService, ITimeoutService} from "angular";
import {Optional} from "../../../util/Optional";

export const WizardStep = "tfWizardStep";

export function tfWizardStep() {
    return {
        templateUrl: "app/js/components/wizard/step/WizardStepComponent.html",
        require: {
            wizard: "^^tfWizard"
        },
        transclude: {
            footerSlot: "?stepFooter"
        },
        bindings: {
            index: "<",
            enabled: "=",
            name: "@",
            skipValidation: "<"
        },
        controllerAs: "ctrl",
        controller: WizardStepComponentController
    };
}

export class WizardStepComponentController implements IOnInit {

    public index: number;
    public name: string;
    public skipValidation: boolean | null;
    public enabled: boolean | null;

    public form: IFormController;
    public wizard: WizardComponentController;

    public visible = false;

    /** @ngInject */
    public constructor(private $element: IRootElementService, private $timeout: ITimeoutService) {

    }

    public $onInit() {
        this.wizard.registerStep(this);
    }

    public isValid(): boolean {
        const skipValidation = Optional.of(this.skipValidation)
                                       .orElse(false);
        if (this.form == null || skipValidation) {
            return true;
        } else {
            this.$timeout(() => this.form.$setSubmitted());
            return this.form.$valid;
        }
    }

    public setVisibility(visible: boolean) {
        this.$timeout(() => this.visible = visible);
        if (visible) {
            this.$element.addClass("active-step");
        } else {
            this.$element.removeClass("active-step");
        }
    }

    public $onDestroy() {
        this.wizard.removeStep(this);
    }
}
